import dayjs from 'dayjs';
import { IGridOperatorCapacity } from 'app/shared/model/grid-operator-capacity.model';

export interface IGridOperatorCapacityTariff {
  id?: number;
  tariff?: number | null;
  effectiveDate?: dayjs.Dayjs | null;
  expirationDate?: dayjs.Dayjs | null;
  gridOperatorCapacity?: IGridOperatorCapacity | null;
}

export const defaultValue: Readonly<IGridOperatorCapacityTariff> = {};
